var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { timeout } from 'rxjs/operators';
import { TimeoutError } from "rxjs";
import { TimeoutInterceptor } from "../interceptors/TimeoutInterceptor";
import { HttpErrorResponse } from "@angular/common/http";
import { from } from 'rxjs';
/**
 * Implementa a interface de response, devolvendo a resposta do servidor
 */
export class AxiosResponse {
    constructor(objectInstance, timeout) {
        this.objectInstance = objectInstance;
        this.timeout = timeout;
        TimeoutInterceptor.setTimeout(this.timeout || 30000);
    }
    buildResponse(request) {
        return __awaiter(this, void 0, void 0, function* () {
            let objectInstance = this.objectInstance;
            return yield new Promise((resolve, reject) => {
                from(request.buildRequest())
                    .pipe(timeout(TimeoutInterceptor.getTimeout()))
                    .subscribe((resp) => __awaiter(this, void 0, void 0, function* () {
                    if (objectInstance instanceof Blob) {
                        resolve(new Blob([yield resp], { type: 'application/pdf' }));
                    }
                    else
                        resolve(Object.assign(objectInstance, resp));
                }), (error) => {
                    if (error instanceof TimeoutError) {
                        error = { 'message': 'Não há comunicação com o servidor. Tente novamente mais tarde.' };
                    }
                    if (error.type == 'error') {
                        error = { 'message': 'Não há comunicação com o servidor. Tente novamente mais tarde.' };
                    }
                    if (error instanceof HttpErrorResponse) {
                        if (error.status == 404) {
                            error = { 'message': 'Erro na requisição de dados.' };
                        }
                        else {
                            error = error.error;
                        }
                    }
                    reject(error.response.data);
                });
            });
        });
    }
}
